import React from 'react'
import { useSelector } from 'react-redux'
import Form from 'antd/lib/form'
import { RootState } from '@store/store'
import Modal from '@UI/antd/Modal'
import useAuth from '@hooks/processor/useAuth'
import FormRender from './FormRender'

const LoginModal = () => {
    const [form] = Form.useForm()
    const login = useSelector((state: RootState) => state.auth.login)
    const { loginModalVisible, loggingIn } = useSelector((state: RootState) => state.ui.authSlider)
    const { data: i18n } = useSelector((state: RootState) => state.localization.locals)
    const { errors, errorLink, resendConfirmationCode, onLogin } = useAuth()

    async function onSubmit(values) {
        onLogin(values, false, true)
    }

    React.useEffect(() => {
        form.setFieldValue('terms', true)
    }, [])

    return (
        <Modal
            // onCancel={() => dispatch(rootActions.ui.authSlider.setLoggedInInfo({ loginModalVisible: false }))}
            open={loginModalVisible}
            modalSize="medium"
            footer={false}
            title={i18n?.General?.ExpiredTokenMsg || 'Your session has expired, Please log in again'}
            maskClosable={false}
            destroyOnClose
        >
            <Form onFinish={onSubmit} form={form}>
                <FormRender
                    i18n={i18n}
                    login={login}
                    errors={errors}
                    errorLink={errorLink}
                    resendConfirmationCode={resendConfirmationCode}
                    loggingIn={loggingIn}
                />
            </Form>
        </Modal>
    )
}

export default LoginModal
